// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UWtD","question":"styles_question__2uP1E","description":"styles_description__B86NW"};